(ns ui.wallet.i18n.en
  "English, the complete reference dictionary of the wallet page and the
   fallback for every other language (see `ui.wallet.i18n`).")

(def dictionary
  {:page/loading "loading..."
   :page/command-failed "Something went wrong. Please try again, or chat with us if it keeps happening."

   :balance/total-available "Total available"
   :balance/pay-as-you-go "Pay-as-you-go balance"
   :balance/used-up "Add credits to keep posting."
   :balance/view-usage "View usage"

   :payment/title "Payment"
   :payment/method "Payment method"
   :payment/billing-email "Billing email"
   :payment/reference "Reference"
   :payment/update "Update payment method"
   :payment/card [:fn/str "Card ({{:last4}})"]
   :payment/wire-transfer "Wire Transfer"

   :billing-email/change "Change"
   :billing-email/new "New billing email"
   :billing-email/save "Save"
   :billing-email/saving "Saving..."
   :billing-email/cancel "Cancel"
   :billing-email/hint "Paddle, our reseller, sends receipts and invoices to this address."
   :billing-email/shared-hint "If several of your organizations share this billing account, the change applies to all of them."
   :billing-email/invalid "Please enter a valid email address."
   :billing-email/taken "This email address is already used by another billing account. Please use a different address or chat with us."

   :customer-conflict/title "Your email is already linked to another account"
   :customer-conflict/text "Your email address already belongs to the billing account of another Storrito organization, and our payment provider Paddle allows only one billing account per email. Please chat with us, and we will sort it out for you."
   :customer-conflict/chat "Chat with support"
   :customer-conflict/support-message "Hi, I can't open the checkout: my email address already belongs to another billing account."

   :top-up/title "Auto Top-Up"
   :top-up/custom-amount "Custom amount"
   :top-up/opening-checkout "Opening checkout..."
   :top-up/amount-missing "Please enter an amount."
   :top-up/amount-too-small [:fn/str "The minimum is ${{:minimum}}."]
   :top-up/amount-too-large [:fn/str "The maximum is ${{:maximum}} per top-up. Please chat with us for larger amounts."]
   :top-up/per-month [:fn/str "${{:quantity}} every month"]
   :top-up/per-year [:fn/str "${{:quantity}} every year"]
   :top-up/stops-on [:fn/str "Stops on {{:date}}"]
   :top-up/next-on [:fn/str "Next top-up on {{:date}}"]
   :top-up/status-cancellation-scheduled "cancellation scheduled"
   :top-up/status-payment-failed "payment failed"
   :top-up/status-active "active"
   :top-up/past-due "The last top-up could not be charged. "
   :top-up/update-payment-method "Update your payment method"
   :top-up/resume "Resume Auto Top-Up"
   :top-up/cancel "Cancel Auto Top-Up"
   :top-up/paddle-unavailable "We could not load your Auto Top-Up details from Paddle right now. Please try again in a moment."
   :top-up/try-again "Try again"

   :plan/title-monthly "Monthly top-up"
   :plan/title-yearly "Yearly top-up"
   :plan/switch "Switch to pay-as-you-go"
   :plan/switching "Switching..."
   :plan/switch-confirm [:fn/str "This ends your recurring ${{:quantity}} top-up now; the switch itself is free. Your credits and your payment method stay. From then on you only pay when you add credits, or automatically with Auto Top-Up."]
   :plan/wont-cover [:fn/str "Your balance probably won't cover your connected Instagram accounts until the next top-up on {{:date}}; stories stop posting at $0."]
   :plan/wont-cover-advice "Turn on Auto Top-Up below, or add credits now."

   :on-demand/add-credits "Add credits"
   :on-demand/choose-amount "Choose an amount. You only pay for what you use."
   :on-demand/auto-top-up "Auto Top-Up"
   :on-demand/rule [:fn/str "When your balance drops below ${{:threshold}}, we add ${{:amount}} automatically."]
   :on-demand/auto-top-up-hint "Optional. Keeps your stories posting when the balance runs low — you can turn it off anytime."
   :on-demand/add [:fn/str "Add ${{:amount}}"]
   :on-demand/charged-once "Charged once now via Paddle, our reseller. Your card is saved for future top-ups, nothing recurring. Credits are non-refundable. Prices excl. VAT."
   :on-demand/discount-off [:fn/str "{{:percent}}% off"]
   :on-demand/discount-applied "Applied to your daily rate from your first top-up, not to the amount you add. Welcome credits are billed at the regular rate."
   :on-demand/charged-to-card "Charged to your saved payment method, available within seconds."
   :on-demand/confirm-charge [:fn/str "You will be charged ${{:amount}} USD excl. taxes now."]
   :on-demand/charging "Charging..."
   :on-demand/add-now [:fn/str "Add ${{:amount}} now"]
   :on-demand/payment-accepted "Payment accepted, your balance updates within a few seconds."
   :on-demand/prices-excl-vat "Prices excl. VAT."
   :on-demand/amount-too-large [:fn/str "The maximum is ${{:maximum}} per top-up."]
   :on-demand/on "On"
   :on-demand/off "Off"
   :on-demand/saving "Saving..."
   :on-demand/save "Save"
   :on-demand/custom-auto-top-up-amount "Custom Auto Top-Up amount"
   :on-demand/one-charge-per-day "At most one automatic charge per day, to your saved payment method, plus applicable taxes."
   :on-demand/remove-payment-method "Remove payment method"

   :transactions/title "Recent transactions"
   :transactions/full-statement "Full statement"
   :transactions/invoices "Invoices"
   :transactions/date "Date"
   :transactions/description "Description"
   :transactions/amount "Amount"
   :transactions/error "The transactions could not be loaded."
   :transactions/empty "No purchases this month yet."
   :transactions/welcome-credits "Welcome credits"
   :transactions/recurring-top-up "Recurring top-up"
   :transactions/added-credits "Added credits"
   :transactions/refund "Credits refund"

   :credit-notes/view "Credit notes"
   :credit-notes/title "Credit notes"
   :credit-notes/intro "Credit notes for your refunds and credits. Paddle, our reseller, issues them."
   :credit-notes/refund "Refund"
   :credit-notes/credit "Credit"
   :credit-notes/download "Download PDF"
   :credit-notes/empty "No credit notes yet."
   :credit-notes/error "The credit notes could not be loaded."

   :offer/applied-automatically "Applied automatically when you add credits. Until then your welcome credits are billed at the regular rate."

   :rates/view "See our rates"
   :rates/title "Our Rates at a Glance"
   :rates/intro "This is what we charge per service. "
   :rates/intro-bold "All prices are quoted in US dollars excluding taxes (excl. VAT)."
   :rates/per-day "per day"
   :rates/per-post "per post"
   :rates/per-image "per image"
   :rates/per-days [:fn/str "per {{:days}} days"]
   :rates/excl-vat "All prices excl. VAT"
   :rates/off [:fn/str "{{:percent}}% OFF"]

   :service.storage-flat-fee/name "Storage flat-fee"
   :service.storage-flat-fee/description "for all your images, videos, etc."
   :service.instagram-connection/name "Instagram account connection"
   :service.instagram-connection/description "Unlimited Stories and Reels for one Instagram username."
   :service.tiktok-post/name "TikTok post"
   :service.tiktok-post/description "Publish a video or image on TikTok."
   :service.youtube-short/name "YouTube Short"
   :service.youtube-short/description "Publish a rendered video as a YouTube Short."
   :service.social-post/name "Social post"
   :service.social-post/description "Publish a rendered video or image on Facebook, Threads and other connected platforms (X is billed separately)."
   :service.x-post/name "X post"
   :service.x-post/description "Publish a rendered video on X. X charges for every post made through its API, so X posts cost more than other social posts."
   :service.x-post-link/name "X post with a link"
   :service.x-post-link/description "An X post whose text contains a link. X charges a lot more for posts with links."
   :service.ai-image/name "AI Image"
   :service.ai-image/description "Generation of an image with AI (Dall-e / Blackforest)."})
